/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

export default function LanguagesIcon({ size, color }) {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_7724_6074" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width={size} height={size}>
        <path d="M0 1.90735e-06H18V18H0V1.90735e-06Z" fill={color} />
      </mask>
      <g mask="url(#mask0_7724_6074)">
        <path d="M4.67578 13.0076L6.18061 9.05646C6.21137 8.98126 6.31779 8.98116 6.34869 9.05629L7.83984 13.0076" stroke="#A6B3C2" strokeWidth="0.9" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.14502 12.0235H7.37804" stroke="#A6B3C2" strokeWidth="0.9" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.38672 3.42773H14.0977" stroke="#A6B3C2" strokeWidth="0.9" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.5904 3.42773V3.76822C12.5904 5.54221 11.2699 7.03881 9.50977 7.25977" stroke="#A6B3C2" strokeWidth="0.9" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.894 3.42773V3.76822C10.894 5.54221 12.2145 7.03881 13.9747 7.25977" stroke="#A6B3C2" strokeWidth="0.9" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.7422 3.42773V2.16211" stroke="#A6B3C2" strokeWidth="0.9" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.1602 0.351562H7.34899C6.51336 0.351562 5.83594 1.02899 5.83594 1.86465V7.55722C5.83594 8.39289 6.51336 9.07031 7.34899 9.07031H13.5L16.1353 11.3203V9.07031C16.971 9.07031 17.6484 8.39289 17.6484 7.55722V1.86465C17.6484 1.02899 16.971 0.351562 16.1353 0.351562H13.3242" stroke="#A6B3C2" strokeWidth="0.9" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.1641 9.07031V13.8853C12.1641 14.721 11.4866 15.3984 10.651 15.3984H4.5L1.86465 17.6484V15.3984C1.02899 15.3984 0.351562 14.721 0.351562 13.8853V8.19278C0.351562 7.35711 1.02899 6.67969 1.86465 6.67969H5.83594" stroke="#A6B3C2" strokeWidth="0.9" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
);
}

LanguagesIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

LanguagesIcon.defaultProps = {
  size: 18,
  color: 'white',
};
